module.exports = __webpack_public_path__ + "static/media/pk_temp.edc60fba.jpg";